import { render } from "./AddProductItems.vue?vue&type=template&id=4344e5f3"
import script from "./AddProductItems.vue?vue&type=script&lang=js"
export * from "./AddProductItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__